/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindingChangelog } from './FindingChangelog';
import { FindingChangelogFromJSON, FindingChangelogFromJSONTyped, FindingChangelogToJSON } from './FindingChangelog';

/**
 *
 * @export
 * @interface PaginatedFindingChangelogList
 */
export interface PaginatedFindingChangelogList {
  /**
   *
   * @type {number}
   * @memberof PaginatedFindingChangelogList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedFindingChangelogList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedFindingChangelogList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<FindingChangelog>}
   * @memberof PaginatedFindingChangelogList
   */
  results: Array<FindingChangelog>;
}

/**
 * Check if a given object implements the PaginatedFindingChangelogList interface.
 */
export function instanceOfPaginatedFindingChangelogList(value: object): value is PaginatedFindingChangelogList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedFindingChangelogListFromJSON(json: any): PaginatedFindingChangelogList {
  return PaginatedFindingChangelogListFromJSONTyped(json, false);
}

export function PaginatedFindingChangelogListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedFindingChangelogList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(FindingChangelogFromJSON),
  };
}

export function PaginatedFindingChangelogListToJSON(value?: PaginatedFindingChangelogList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(FindingChangelogToJSON),
  };
}
